document.querySelectorAll("[data-slideshow]").forEach($wrapper => {

	const $slideshow = $wrapper.querySelector("[data-slideshow-track]");

	const $items = $slideshow.children;
	if($items.length < 2) {
		return;
	}
	const $stations = $slideshow.querySelectorAll(".stationItem > div");

	const $puntini = $wrapper.querySelectorAll("[data-slideshow-dot]");
	let timer;

	let current = 0;
	//Cambia avviso
	const cambia_slide = (newCurrent) => {
		if(newCurrent < 0) {
			newCurrent = $items.length - 1;
		}
		if(newCurrent > $items.length - 1) {
			newCurrent = 0;
		}
		//Scrolla
		$slideshow.scroll({
			top: 0,
			left: $slideshow.offsetWidth * newCurrent,
			behavior: "smooth",
		});
	}

	// Ferma cambiamento automatico
	const ferma_cambia_auto = () => clearTimeout(timer);

	//Avvia cambiamento automatico
	const avvia_cambia_auto = () => {
		ferma_cambia_auto();
		timer = setTimeout(cambia_auto, $wrapper.dataset.slideshowAutoplay);
	}

	//Cambia automatico
	const cambia_auto = () => {
		cambia_slide(current + 1);
		avvia_cambia_auto();
	}

	$slideshow.addEventListener("scroll", e => {
		const position = e.currentTarget.scrollLeft / e.currentTarget.offsetWidth;
		current = Math.round(position);
		$puntini.forEach(($puntino, index) => $puntino.classList[index === current ? "add" : "remove"]("active"));
		if($stations.length) {
			$stations.forEach(($item, index) => {
				const pos = position - index;
				$item.style.opacity = 1 - Math.abs(pos * 0.5);
				$item.style.transform = `rotateY(${pos * 20}deg)`;
			})
		}
	});
	//Accrocchio per non farlo laggare alla prima animazione
	if($stations.length) {
		window.setTimeout(function() {
			cambia_slide(1);
			window.setTimeout(function() {
				cambia_slide(0);
			}, 40)
		}, 5)
	}

	$wrapper.querySelector("[data-slideshow-nav]")?.addEventListener("click", (e) => {
		if(e.target.hasAttribute("data-slideshow-dir")) {
			//Arrow
			cambia_slide(current + parseInt(e.target.dataset.slideshowDir));
		}
		if(e.target.hasAttribute("data-slideshow-dot")) {
			//Puntino
			cambia_slide(parseInt(e.target.dataset.slideshowDot));
		}
	})


	if($wrapper.dataset.slideshowAutoplay) {
		avvia_cambia_auto();
		$slideshow.addEventListener("mouseenter", ferma_cambia_auto);
		$slideshow.addEventListener("mouseleave", avvia_cambia_auto);
	}

});
($slideshow => {
	if(!$slideshow) {
		return;
	}
	const $items = $slideshow.querySelectorAll(".homeSlideshowItem");
	const intervallo = 4100;
	let current = 0;
	let timer;

	const cambia_immagine_home = (dir) => {
		$items[current].classList.remove("active");
		current += parseInt(dir);
		if(current > ($items.length - 1)) {
			current = 0;
		}
		if(current < 0) {
			current = $items.length - 1;
		}
		if($items[current].hasAttribute("data-ken-burns")) {
			$items[current].classList.remove("kenBurns");
			requestAnimationFrame(() => $items[current].classList.add("kenBurns"));
		}
		$items[current].classList.add("active");
	}

	const ferma_cambia_auto = () => clearTimeout(timer);

	const avvia_cambia_auto = () => {
		ferma_cambia_auto();
		timer = setTimeout(cambia_auto, intervallo);
	}

	const cambia_auto = () => {
		cambia_immagine_home(1);
		avvia_cambia_auto();
	}

	avvia_cambia_auto();

	if($items[current].hasAttribute("data-ken-burns")) {
		$items[current].classList.remove("kenBurns");
		requestAnimationFrame(() => $items[current].classList.add("kenBurns"));
	}

	$slideshow.addEventListener("mouseenter", ferma_cambia_auto);
	$slideshow.addEventListener("mouseleave", avvia_cambia_auto);
	$slideshow.addEventListener("click", e => {
		if(e.target.dataset.dir) {
			cambia_immagine_home(e.target.dataset.dir);
		}
	});
}) (document.querySelector(".homeSlideshow"));
document.addEventListener("DOMContentLoaded", () => {

	if(document.querySelector(".newstickerLinksContainer")) {
		//Setta la partenza dell'animazione del newsticker
		const width_container_newsticker = document.querySelector(".newstickerLinksContainer").offsetWidth;

		document.documentElement.style.setProperty('--width-container-newsticker', width_container_newsticker + "px");


		//Setta la durata dell'animazione
		const width_newsticker = document.querySelector(".newstickerLinks").offsetWidth;
		const animation_speed = 50; //Velocità espressa in px/s

		document.documentElement.style.setProperty('--duration-animation-newsticker', width_newsticker / animation_speed + "s");
	}
});;
($gallerie => {
	if(!$gallerie.length) {
		return;
	}
	$gallerie.forEach($galleria => {

		$galleria.addEventListener("click", function(e) {
			if(e.target.dataset.pos) {
				//ID galleria
				const id_galleria = $galleria.dataset.idGalleria;

				//ID immagine
				const id_immagine_cliccata = e.target.dataset.pos;

				const $popup_galleria = document.querySelector(`.galleriaContainerPopup[data-id-galleria='${id_galleria}']`);

				//Attiva il popup
				$popup_galleria.classList.add("active");

				//Metti la classe sull'immagine
				$popup_galleria.querySelector(`[data-pos='${id_immagine_cliccata}']`).classList.add("visibile");

			}
		})


	});
	const chiudi_popup = ($popup) => {
		//Immagine attuale
		const $current_immagine = $popup.querySelector(".visibile");

		//Rimuovi classe da immagine attuale
		$current_immagine.classList.remove("visibile");

		//Rimuovi classe da popup
		$popup.classList.remove("active");
	}

	document.querySelectorAll(`.galleriaContainerPopup`).forEach($popup => {
		//Frecce
		$popup.addEventListener("click", function(e) {
			if(e.target.classList.contains("galleriaPopupArrow")) {
				//Immagini / Video
				const $items = $popup.querySelectorAll(".galleriaItemContainerImage");

				//Direzione
				const dir = parseInt(e.target.dataset.dir);

				//Immagine attuale
				const $current_immagine = $popup.querySelector(".visibile");

				//Rimuovi classe da immagine attuale
				$current_immagine.classList.remove("visibile");

				let current_id_immagine = parseInt($current_immagine.dataset.pos);

				current_id_immagine += parseInt(dir);
				if(current_id_immagine > ($items.length - 1)) {
					current_id_immagine = 0;
				}
				if(current_id_immagine < 0) {
					current_id_immagine = $items.length - 1;
				}
				$items[current_id_immagine].classList.add("visibile");
			}
			//Chiudi
			if(e.target.classList.contains("galleriaPopupChiuditore")) {
				chiudi_popup($popup);
			}
		});
	});

	window.addEventListener("keydown", function(e) {
		const $popup = document.querySelector(".galleriaContainerPopup.active");
		if(e.key === "Escape") {
			if($popup) {
				chiudi_popup($popup);
			}
		}
		if(e.key === "ArrowRight") {
			if($popup) {
				$popup.querySelector("[data-dir='1']").click();
			}
		}
		if(e.key === "ArrowLeft") {
			if($popup) {
				$popup.querySelector("[data-dir='-1']").click();
			}
		}
	})

}) (document.querySelectorAll("[data-id-galleria]"));
{
	if(document.documentElement.dataset.autoAcceptCookies) {
		localStorage.setItem("preferenzeCookie", JSON.stringify(["statistiche", "marketing"]));
	}

	//Visualizza il banner delle preferenze
	const visualizzaPreferenzeCookies = () => {
		document.querySelector(".cookiesContainer").classList.add("visible");
		//Preset delle opzioni già accettate
		const userConditions = JSON.parse(window.localStorage.getItem("preferenzeCookie"));
		if(userConditions) {
			[...document.querySelectorAll(".cookiesSwitchesContainer input")].map(($input) => $input.checked = userConditions.includes($input.name));
		}
	}
	if(!localStorage.getItem("preferenzeCookie")) {
		visualizzaPreferenzeCookies();
	}
	document.querySelectorAll("[data-modifica-consenso]").forEach(function($button) {
		$button.addEventListener("click", visualizzaPreferenzeCookies);
	});

	//Gestione tasti preferenze
	document.querySelector(".cookiesButtonsContainer").addEventListener("click", function(e) {
		let stringCookie;
		switch(e.target.dataset.accept) {
			case "0":
				stringCookie = [];
				break;
			case "1":
				stringCookie = [...document.querySelectorAll(".cookiesSwitchesContainer input:checked")].map(($input) => $input.name);
				break;
			case "2":
				stringCookie = ["statistiche", "marketing"];
				break;
			default:
				return;
		}
		localStorage.setItem("preferenzeCookie", JSON.stringify(stringCookie));

		document.querySelector(".cookiesContainer").classList.remove("visible");

		checkCookies();
	})
	//Gestione caricamento parti che utilizzano cookies
	const checkCookies = () => {
		const userConditions = JSON.parse(window.localStorage.getItem("preferenzeCookie"));
		if(userConditions) {
			window.cookieConditioned = window.cookieConditioned.filter((el) => {
				if(el[0].every((condition) => userConditions.includes(condition))) {
					el[1]();
					return false;
				}
				return true;
			})
		}
	}

	checkCookies();
};
window.addEventListener("click", (e) => {
	let $lightbox = false;
	const $target = e.target;
	if($target.dataset.videoLightbox) {
		if($lightbox === false) {
			//Crea tutto il markup del lightbox
			$lightbox = document.createElement("div");
			$lightbox.classList.add("lightboxContainer");
			$lightbox.innerHTML = `<video loop playsinline controls poster=''><source src="" type='video/mp4'></video>`;
			//Aggancia evento chiusura (ferma video e chiudi)
			document.body.appendChild($lightbox);
			$lightbox.addEventListener("click", (e) => {
				if(e.target.classList.contains("lightboxContainer")) {
					$lightbox.querySelector("video").pause();
					$lightbox.classList.remove("active");
				}
			})
		}
		//Setta src e cover
		$lightbox.querySelector("video").poster = $target.dataset.videoLightboxCover;
		$lightbox.querySelector("video source").src = $target.dataset.videoLightbox;
		//Apri lightbox
		$lightbox.classList.add("active");
		//Avvia video
		$lightbox.querySelector("video").play();
	}
});
{
	let meteoPanomaxCount = 0;
	document.querySelectorAll("[data-meteo-panomax]").forEach($el => {
		const id = `i${meteoPanomaxCount}`;
		meteoPanomaxCount++;
		$el.id = id;
		PmaxThumbnail.place({
			culture: "it-IT",
			target: "_blank",
			height: 405,
			instanceName: false,
			instanceLogo: false,
			map: false,
			weather: false,
			timelapse: false,
			id: id,
			instance: $el.dataset.meteoPanomax,
			continuous: !!$el.dataset.meteoPanomaxThreeSixty
		});
	})
}
;
document.querySelectorAll(".articoloWrapper").forEach($wrapper => {
	const $$tables = $wrapper.querySelectorAll("[data-data]");
	$wrapper.querySelectorAll("input[type='date']").forEach(function($date) {
		$date.addEventListener("change", applyFilter);
	})
	$wrapper.querySelector("button").addEventListener("click", function() {
		window.requestAnimationFrame(applyFilter);
	})

	function checkFrom(data, from) {
		return data >= from;
	}
	function checkTo(data, to) {
		return data <= to;
	}

	function applyFilter() {
		const from = $wrapper.querySelector("input[name='from']").value;
		const to = $wrapper.querySelector("input[name='to']").value;

		$$tables.forEach(function($table) {
			const data = $table.dataset.data;
			if(from && to) {
				if(checkFrom(data, from) && checkTo(data, to)) {
					$table.style.display = "block";
				} else {
					$table.style.display = "none";
				}
			} else if(from) {
				if(checkFrom(data, from)) {
					$table.style.display = "block";
				} else {
					$table.style.display = "none";
				}
			} else if(to) {
				if(checkTo(data, to)) {
					$table.style.display = "block";
				} else {
					$table.style.display = "none";
				}
			} else {
				$table.style.display = "block";
			}
		})
	}
});
;
['left', 'center', 'right'].forEach(alignment => window.customElements.define(`align-${alignment}`, class extends HTMLElement {
	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
		this.shadowRoot.innerHTML = `<style>:host{ text-align: ${alignment}; width: 100%; display: block; }</style><slot></slot>`;
	}
}));
;
{
	const autosize = el => {
		el.style.height = "";
		const style = window.getComputedStyle(el);
		el.style.height = `${el.scrollHeight + parseInt(style.getPropertyValue("border-top-width")) + parseInt(style.getPropertyValue("border-bottom-width"))}px`;
	};

	document.addEventListener("input", e => {
		if(e.target.tagName === "TEXTAREA") {
			autosize(e.target);
		}
	});

	document.querySelectorAll("textarea").forEach(autosize);

	window.autosizeTextarea = autosize;
}
;
document.querySelectorAll("[data-main-select]").forEach(select => {
	select.addEventListener("change", e => {
		document.querySelectorAll(`[data-sub-select="${select.dataset.mainSelect}"]`).forEach(subSelect => {
			if(subSelect.dataset.mainSelectValue === select.value) {
				subSelect.required = true;
				subSelect.classList.add("active");
			} else {
				subSelect.required = false;
				subSelect.classList.remove("active");
			}
		});
	});
});;;